<template>
    <app-layout>
        <template #header>
            <AppHead title="All Payments" />
            <h2>Payment History</h2>
        </template>

        <card title="Account Statement" class="mb-3 mt-4">
            <div class="row">
                <div class="col-4">
                    <jet-label for="start_date" value="Select Start Date" />
                    <Calendar class="w-100" v-model="start_date" dateFormat="mm/dd/yy" show-icon="true" />
                </div>

                <div class="col-4">
                    <jet-label for="end_date" value="Select End Date" />
                    <Calendar class="w-100" v-model="end_date" dateFormat="mm/dd/yy" show-icon="true" />
                </div>

                <div class="col-4 text-center w-100">
                    <jet-button class="w-100" icon="fas fa-file-invoice" btnStyle="success"
                        @click="openPrintAccountActivity">Print</jet-button>
                </div>
            </div>
        </card>

        <div class="mt-4">
            <inertia-link :href="route('tu.balancepayment', $page.props.auth.user.id)">
                <jet-button icon="fas fa-dollar-sign">Make Payment</jet-button>
            </inertia-link>
        </div>

        <section v-if="$page.props.payments" class="mt-3">
            <DataTable :value="$page.props.payments" :rowClass="() => { return 'table-row' }" breakpoint="992px" stripedRows
                id="paymentsTable" :paginator="true" :rows="50" class="p-datatable-sm"
                tableClass="border-left border-right border-bottom" @row-click="e => openPrintPaymentReceipt(e.data.id)">
                <Column field="date" header="Date">
                    <template #body="slotProps">
                        <span v-if="slotProps.data.transaction_date">{{
                            moment(slotProps.data.transaction_date).format('M/D/YY h:mm A') }}</span>
                    </template>
                </Column>
                <Column field="id" header="Payment">
                    <template #body="slotProps">
                        <PaymentType class="ml-2" :payment="slotProps.data" />
                    </template>
                </Column>
                <Column field="amount" header="Amount">
                    <template #body="slotProps">
                        {{ formatDollars(slotProps.data.amount) }}
                    </template>
                </Column>
            </DataTable>
        </section>
    </app-layout>
    <teleport to="body">
        <PrintModal :printUrl="printUrl" @print="print" />
    </teleport>
</template>

<script>
import moment from 'moment'
import AppLayout from '@/Layouts/AppLayout'
import PaymentType from '@/Components/Transaction/PaymentType'
import PrintModal from '@/Components/Modals/PrintModal'
import Calendar from "primevue/calendar"

export default {
    components: {
        AppLayout,
        PaymentType,
        PrintModal,
        Calendar,
    },
    data: {
        selectedReceiptPaymentId: null,
        printReport: '',
        printUrl: '',
        start_date: moment().date(1).month('January').format('M/D/Y'),
        end_date: moment().endOf('month').format('M/D/Y'),
    },
    created() {
        this.moment = moment
    },
    methods: {
        openPrintPaymentReceipt(paymentId) {
            this.printReport = 'tu.payment.receipt'
            this.selectedReceiptPaymentId = paymentId
            this.openPrintDialog();
        },
        openPrintAccountActivity() {
            this.printReport = 'tu.report.accountActivity'
            this.openPrintDialog();
        },
        openPrintDialog() {
            this.setPrintUrl(0);
            $('#PrintModal').modal('show');
        },
        print() {
            this.setPrintUrl(1);
        },
        setPrintUrl(print) {
            switch (this.printReport) {
                case 'tu.payment.receipt':
                    this.printUrl = this.route('tu.payment.receipt', { payment: this.selectedReceiptPaymentId, print: print });
                    break;
                case 'tu.report.accountActivity':
                    this.printUrl = this.route('tu.report.accountActivity',
                        { user: this.$page.props.auth.user.id, start: this.dayStartUTC(this.start_date), end: this.dayEndUTC(this.end_date), utcOffset: moment().utcOffset(), print: print });
                    break;
            }
        },
        dayStartUTC(date) {
            return moment.utc(moment(date).startOf('day')).unix();
        },
        dayEndUTC(date) {
            return moment.utc(moment(date).endOf('day')).unix();
        },
    }
}
</script>

<style>
.table-row {
    cursor: pointer;
}
</style>
